import { useItemContext, useRootContext } from "./hooks";

/**
 * Whether a trigger is disabled, on every platform: any of its own, the
 * item's or the root's `disabled`, so a trigger's `false` doesn't enable it
 * under a disabled item or root. @rn-primitives resolves it this way; the web
 * trigger passes it to Radix, which would let the trigger's own `false` win.
 */
export const useTriggerDisabled = (triggerDisabled?: boolean): boolean => {
  const root = useRootContext();
  const item = useItemContext();
  return Boolean(triggerDisabled) || Boolean(root.disabled) || Boolean(item.disabled);
};
